import React from 'react';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import Navbar from './components/Navbar';
import Footer from './components/Footer';
import Home from './pages/Home';
import RankedChoiceVoting from './pages/RankedChoiceVoting';
import About from './pages/About';
import Map from './pages/Map';
import EntityPage from './pages/EntityPage';
import SummaryData from './pages/SummaryData';
import Legislation from './pages/Legislation';
import './styles/App.css';
import './styles/global.css';
import 'react-tooltip/dist/react-tooltip.css'; // Import react-tooltip CSS

function App() {
    return (
        <Router>
            <div className="App">
                <Navbar />
                <main>
                    <Routes>
                        <Route path="/" element={<Home />} />
                        {/* <Route path="/legislation" element={<Legislation />} /> */}
                        <Route path="/ranked-choice-voting" element={<RankedChoiceVoting />} />
                        <Route path="/summary-data" element={<SummaryData />} /> {/* Correct */}
                        {/* {<Route path="/about" element={<About />} />} */}
                        <Route path="/map" element={<Map />} />
                        {/* <{Route path="/:entity" element={<EntityPage />} }/> */}
                    </Routes>
                </main>
                <Footer />
            </div>
        </Router>
    );
}

export default App;
